var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{attrs:{"app-name":"mail"}},[_c('Navigation'),_vm._v(" "),(_vm.$route.name === 'outbox')?_c('Outbox'):(_vm.activeAccount)?_c('MailboxThread',{attrs:{"account":_vm.activeAccount,"mailbox":_vm.activeMailbox}}):_vm._e(),_vm._v(" "),(_vm.$store.getters.showMessageComposer)?_c('NewMessageModal',{on:{"close":_vm.onCloseModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }